import React, { createContext, useCallback, useContext, useState } from 'react';
import { useLocationTracking } from '../hooks/useLocationTracking';
import { LocationDisclosure, LocationRefusedBanner } from '../components/LocationDisclosure';

const CONSENT_KEY = 'propilote_location_consent';
const IS_NATIVE = typeof window !== 'undefined' && window.__IS_NATIVE__ === true;

const LocationContext = createContext({
  isTracking: false,
  isConnected: false,
  lastPosition: null,
  error: null,
  startTracking: () => {},
  stopTracking: () => {},
});

// Divulgation bien visible (Google Play) : aucune demande de permission avant « Accepter »
const readConsent = () => (IS_NATIVE ? localStorage.getItem(CONSENT_KEY) : 'accepted');

export const LocationProvider = ({ enabled, children }) => {
  const [consent, setConsent] = useState(readConsent);
  const tracking = useLocationTracking({ enabled: enabled && consent === 'accepted' });

  const decide = useCallback((value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setConsent(value);
  }, []);

  const requestConsent = useCallback(() => {
    localStorage.removeItem(CONSENT_KEY);
    setConsent(null);
  }, []);

  return (
    <LocationContext.Provider value={{ ...tracking, consent, requestConsent }}>
      {children}
      {enabled && !consent && (
        <LocationDisclosure onAccept={() => decide('accepted')} onRefuse={() => decide('refused')} />
      )}
      {enabled && consent === 'refused' && (
        <LocationRefusedBanner onEnable={requestConsent} />
      )}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => useContext(LocationContext);
